import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { ListingCard } from "@/components/ListingCard";
import { api } from "@/lib/api";

export function SimilarItems({ listing }) {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get(`/listings/${listing.id}/similar`).then((r) => setItems(r.data)).catch(() => {}); }, [listing.id]);
  if (!items.length) return null;
  return (
    <section data-testid="similar-items" className="mt-16">
      <div className="mb-6 flex items-end justify-between gap-4">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#d4f253]">Missed out?</p>
          <h2 className="mt-2 font-display text-2xl font-bold">You might also like</h2>
        </div>
        <Link to={`/browse?category=${listing.category}`} data-testid="similar-browse-link" className="flex items-center gap-1 text-sm font-semibold text-[#d4f253] hover:underline">See more <ArrowRight className="h-4 w-4" /></Link>
      </div>
      <div className="grid grid-cols-2 gap-4 sm:gap-6 lg:grid-cols-4">{items.map((l, i) => <ListingCard key={l.id} l={l} i={i} />)}</div>
    </section>
  );
}
